/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '../core/request';

export class RedisService {
  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async getKeys(): Promise<any> {
    const result = await __request({
      method: 'GET',
      path: `/api/v1/cache`,
    });
    return result.body;
  }

  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async deleteKey({ id }: { id: string }): Promise<any> {
    const result = await __request({
      method: 'DELETE',
      path: `/api/v1/cache/${id}`,
    });
    return result.body;
  }

  /**
   * @returns any Default Response
   * @throws ApiError
   */
  public static async purge(): Promise<any> {
    const result = await __request({
      method: 'GET',
      path: `/api/v1/cache/purge`,
    });
    return result.body;
  }
}
